import * as React from 'react';

import {TextField} from 'shells/textfield/textfield';

import type {DueDateUnit} from 'nutshell-graphql-types';
import type {TimespanInput} from 'nutshell-graphql-types';

import {DueUnitPicker} from './fields/due-unit-picker';

import styles from './date-time-picker.module.css';

type Props = {
    overdueDuration: TimespanInput;
    onOverdueDurationChange: (arg1: TimespanInput) => void;
};

export class OverdueDurationInput extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles['date-picker']}>
                <div className={styles['timespan-input']}>
                    <TextField
                        type='number'
                        value={String(this.props.overdueDuration.timespan)}
                        min='1'
                        selectOnFocus={true}
                        // @ts-expect-error
                        name='overdue-duration-timespan'
                        onChange={this.handleOverdueDurationTimespanChange}
                    />
                </div>
                <div className={styles['selector-container']}>
                    <DueUnitPicker
                        value={this.props.overdueDuration.unit}
                        onChange={this.handleOverdueDurationUnitChange}
                        isSingleUnit={this.props.overdueDuration.timespan === 1}
                    />
                </div>
            </div>
        );
    }

    handleOverdueDurationTimespanChange = (newValue: string) => {
        const newOverdueDuration = {
            timespan: Number(newValue),
            unit: this.props.overdueDuration.unit,
        } as const;

        this.props.onOverdueDurationChange(newOverdueDuration);
    };

    handleOverdueDurationUnitChange = (newValue: {id: DueDateUnit}) => {
        const newOverdueDuration = {
            timespan: this.props.overdueDuration.timespan,
            unit: newValue.id,
        } as const;

        this.props.onOverdueDurationChange(newOverdueDuration);
    };
}
